'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// /workspace/Release/~/react-dom/index.js
// module id = 30
// module chunks = 0 1 2 3 4 5 6